module.exports = ".changelog-header {\n  font-weight: bold;\n  overflow-x: hidden; }\n\n.changelog-block:not(:last-child) .row:last-child {\n  border-bottom: 1px solid lightgray; }\n\n.changelog-headers {\n  margin-top: -10px;\n  border-bottom: 1px solid lightgray; }\n\n.changelog-block:last-child {\n  margin-bottom: -15px; }\n\n.changelog-block {\n  overflow-wrap: break-word; }\n\n.changelog-block.odd .row {\n  background-color: #f8f8f8; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/changelog/changelog.component.scss
// module id = ./src/app/shared/changelog/changelog.component.scss
// module chunks = main